<template>
  <v-row justify="center">
    <v-dialog
        v-model="this.$store.state.processedDialog"
        persistent
        width="624"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5" style="margin-bottom: 30px">معالجة الطلب</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
               <h1 class="text-center">هل انت متأكد من معالجة الطلب ؟</h1>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue-darken-1"
              variant="text"
              @click="$store.state.processedDialog = false"
          >
            الغاء
          </v-btn>
          <v-btn
              color="blue-darken-1"
              variant="text"
              @click="handleProcessed"
          >
            معالجة
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style>
.horizontal{
  margin: -18px;
  margin-bottom: 25px
}

.reasonLabel{
  margin-right: 18px;
  font-weight: bold;
}

.inputReason{
  width: 100%;
  border: 1px solid gray;
  height: 40px;
  outline: none;
  border-radius: 7px;
  padding: 5px;
}
</style>

<script>

import Axios from "axios";

export default {
  name: 'RefuseRequest',

  data(){
    return{
      reason: '',
    }
  },

  methods:{
    handleProcessed(){
      let url = `${this.$store.state.url}/v2/employee/Requests/processNeedToBeTurnedQualityReqNew/${this.$store.state.processedId}`
      Axios.get(url, {headers:this.request_headers()}).then(res => {
        this.$store.state.processedDialog = false
        this.showPopup("success", res.data.message);
        this.$emit("handleProcess")
      }).catch(err => {
        let error = { err };
        this.$store.state.processedDialog = false
      })
    }
  }
}
</script>